/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateSitesOfDeliveryMethod$Params {
  deliveryMethodId: string;
      body: Array<string>
}

export function updateSitesOfDeliveryMethod(http: HttpClient, rootUrl: string, params: UpdateSitesOfDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSitesOfDeliveryMethod.PATH, 'put');
  if (params) {
    rb.path('deliveryMethodId', params.deliveryMethodId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSitesOfDeliveryMethod.PATH = '/delivery/methods/{deliveryMethodId}/sites';
